

<div class="map" id="map"></div>

<div *ngIf="showDonationModal" id="gridSystemModal" class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="gridModalLabel" style="padding-right: 17px; display: block;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="gridModalLabel">Faire un don</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDonationModal()"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
          <div class="container">
              <div class="text-center">
                <img src="https://img.icons8.com/cotton/2x/donate--v1.png" width="100px">
              </div>
            <p>Des milliers de personnes comme vous nous aident à défendre contre COVID-19. Nous comptons sur vos dons pour achever notre mission. <br/>Acceptez-vous de faire un don ?</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeDonationModal()">FERMER</button>
          <button type="button" class="btn btn-primary" routerLink="/donation">FAIRE UN DON</button>
        </div>
      </div>
    </div>
  </div>


<div *ngIf="! showDonationModal" class="bottom-btn-block">
    <button type="button" class="btn btn-danger btn-rnd btn-sm round-when-mb" routerLink="/declaration" ><span class="can-hide-mb">JE PENSE QUE JE SUIS MALADE </span><i class="fas fa-medkit"></i></button>
</div>

<div *ngIf="! showDonationModal" class="my-position">
    <button type="button" class="btn btn-info btn-rnd btn-sm round-when-mb" (click)="getMyPosition()" > <span class="can-hide-mb">MA POSITION</span><i class="fas fa-street-view"></i></button>
</div>


<div *ngIf="! showDonationModal" class="legende">
    <div class="legend-box"> 
        <div class="legende-box confirmed"></div>
        CAS CONFIRMÉ
    </div> 
    <div class="legend-box"> 
        <div class="legende-box suspected"></div>
        CAS SUSPECTS(pas confirmé)
        
    </div> 
    <div class="legend-box"> 
        <div class="legende-box new"></div> NOUVEAU CAS(pas confirmé)
    </div>
    <a class="about-l" routerLink="/about">À propos le<br/> développeur d'application.<br/></a>
    <small style="color: white;">Controlé par <br/><strong style="color: #F44336;">Services d'aide médicale urgente(SAMU).</strong></small> 
    <br/>
    <a href="https://opengeodata-ageos-tunisie.hub.arcgis.com/" style="color: white;">Source des cas confirmés</a>
    
</div>


<!--<div class="search-zone">
    <div class="serach-bow">
        <input type="search" class="form-control" placeholder="Recherche par numéro de téléphone,nom" [(ngModel)]="searchQuery" (keyup)="searchFor($event)">
    </div>
    <div class="search-result" *ngIf="seachInfections.length !=0">
        <table class="table">
            <tr *ngFor=" let infect of seachInfections ">
                <td>
                    <a [routerLink]="['/infected/'+infect+id ]">{{ infect.data.userinformations.fullname}}<br/>
                    <small>{{ infect.data.userinformations.phone}}</small></a>
                </td>
            </tr>
        </table>
    </div>
</div>-->


<div  class="showLatestInefect-bloc" *ngIf="! showLatestBloc">
    <button class="btn btn-sm btn-secondary" (click)="toggleLatest()">AFFICHER LA LISTE DES DÉTAILS</button>
</div>

<div  class="latest-infections" *ngIf="showLatestBloc">
    <div class="latest-infection-list " style="position: relative;">
        <div (click)="toggleLatest()" class="closebtn"><i class="fas fa-times"></i></div>
        <div  *ngFor="let infect of infectionVisualList " class="infection-bloc">
            <div *ngIf="infect.stat==2">
                <strong class="color-conf">CAS CONFIRMÉ<span *ngIf="infect.userinformations.region!=null"> ({{infect.userinformations.region}})</span> </strong>
            </div>
            <div *ngIf="infect.stat==1">
                <strong class="color-sus">CAS SUSPECTS(pas confirmé)<span *ngIf="infect.userinformations.region!=null"> ({{infect.userinformations.region}})</span> </strong>
            </div>
            <div *ngIf="infect.stat==0">
                <strong class="color-new">NOUVEAU CAS(pas confirmé)<span *ngIf="infect.userinformations.region!=null"> ({{infect.userinformations.region}})</span> </strong>
            </div>
            <strong>{{ infect.addDate.toDate() | date:'medium' }}</strong><br/>
            <strong> <span *ngIf="infect.userinformations.sex==1">HOMME</span> <span *ngIf="infect.userinformations.sex==2">FEMME</span>  {{ infect.userinformations.age }}</strong><br/>
            <button class="btn btn-sm btn-secondary" (click)="flyToPosition(infect.position)">VOIR SUR LA CARTE</button>
            <hr/>
        </div>
    </div>
</div>


<div *ngIf="! showDonationModal" class="small-stat-block" routerLink="/statistic">
    <app-statistic></app-statistic>
</div>


<div class="serverIsFull" *ngIf="serverIsFull" style="    z-index: 100000000000000000000000000000000;">
    <div class="container my-5">
        <img src="https://cdn2.iconfinder.com/data/icons/databases-and-cloud-technology/48/56-512.png" width="150px">
        <h3>Oups, on dirait que le serveur est plein, veuillez revenir plus tard, nous sommes vraiment désolés. <br/>mais vous pouvez toujours utiliser la fonction d'urgence.</h3>
        <button class="btn btn-primary" (click)="closeServerAlert()" style="margin-right: 15px;">FERMER</button>
        <button class="btn btn-danger" (click)="closeServerAlert()"  routerLink="/declaration" style="margin-right: 15px;">URGENCE</button>
        

    </div>
</div>




<div class="showDeatailsBloc-bloc" *ngIf="! showDeatailsBloc">
    <button class="btn btn-sm btn-secondary" (click)="toggleDtailsBloc()">AFFICHER LES DÉTAILS</button>
</div>
<div class="counting-engine" *ngIf=" showDeatailsBloc ">
    <div style="position: relative;    padding: 15px;">
        <div (click)="toggleDtailsBloc()" class="closebtn"><i class="fas fa-times"></i></div>
        <h3>TUNISIA</h3>
        <div class="row">
            <div class="col-sm-6">
                <span class="nrb-of-index">{{ restedHumans }}</span> RÉTABLI<br/>
                <span class="nrb-of-index">{{ nbgOfDeath}}</span> DÉCÈS<br/>
                <span class="nrb-of-index">{{ quarentaine }}</span> NB QUARANTAINE<br/>
                
            </div>
            <div class="col-sm-6">
                <span class="nrb-of-index">{{ NewCases}}</span> NOUVEAU CAS<br/>
                <span class="nrb-of-index">{{ totalCasess}}</span> CAS CONFIRMÉ<br/>
            </div>
        </div>
    </div>
</div>



